const TOKEN_TAG = 'wallet_app_user_token';
const NAME_TAG = 'wallet_app_name';
const EXPIRES_AT_TAG = 'wallet_app_expire_tag';

// const SERVER_BASE_URL = "http://localhost:8081";
const SERVER_BASE_URL = 'https://api.xpenso.xyz';
const BACKEND_SERVER = 'https://api.xpenso.xyz';

const NEW_USER_KEY = 'isNewUser';
// const SERVER_BASE_URL = "http://virtual-wallet-server:8080";

export { TOKEN_TAG, NAME_TAG, EXPIRES_AT_TAG, SERVER_BASE_URL, NEW_USER_KEY, BACKEND_SERVER };
